import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/providers/AuthProvider';

const LOGO_URL = 'https://framerusercontent.com/images/FapOIHYkbZYulb06Azfkyxn8Qt8.png';

export function LoginPage() {
  const [params] = useSearchParams();
  const returnTo = params.get('returnTo') ?? '/dashboard';
  const { startGoogleLogin } = useAuth();

  return (
    <Card className="w-full max-w-md shadow-card">
      <CardHeader className="items-center text-center">
        <img
          src={LOGO_URL}
          alt="AlignMate"
          className="mb-2 h-12 w-auto select-none"
          draggable={false}
          loading="eager"
        />
        <CardTitle className="gradient-brand-text text-2xl">AlignMate Admin</CardTitle>
        <CardDescription>Sign in with your authorized Google account to continue.</CardDescription>
      </CardHeader>
      <CardContent className="pt-2">
        <Button
          type="button"
          size="lg"
          variant="gradient"
          className="w-full"
          onClick={() => startGoogleLogin(returnTo)}
        >
          <GoogleGlyph className="h-4 w-4" />
          Sign in with Google
        </Button>
      </CardContent>
      <CardFooter className="flex-col items-start gap-1 border-t pt-4 text-xs text-muted-foreground">
        <div>Access restricted to admins seeded in the backend allow-list.</div>
        <div>Session lifetime: ~24h. You can sign out anytime from the top-right menu.</div>
      </CardFooter>
    </Card>
  );
}

function GoogleGlyph({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 48 48" aria-hidden>
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.8 32.4 29.3 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.3 1 7.3 2.7l5.7-5.7C33.4 6.6 28.9 5 24 5 13.5 5 5 13.5 5 24s8.5 19 19 19 19-8.5 19-19c0-1.3-.1-2.3-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.1l6.6 4.8C14.7 15.1 19 12 24 12c2.8 0 5.3 1 7.3 2.7l5.7-5.7C33.4 6.6 28.9 5 24 5 16.3 5 9.7 9.2 6.3 14.1z" />
      <path fill="#4CAF50" d="M24 43c4.8 0 9.2-1.8 12.5-4.9l-5.8-4.9c-2 1.5-4.5 2.4-7.2 2.4-5.3 0-9.7-3.5-11.3-8.3l-6.5 5C9.5 38.7 16.2 43 24 43z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.2 5.5l5.8 4.9C40 34.4 43 29.7 43 24c0-1.3-.1-2.3-.4-3.5z" />
    </svg>
  );
}
